


































































import { Vue, Component } from "vue-property-decorator";
import SpatialNavigation from "spatial-navigation-js";
import { Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import {
  SettingsGetters,
  SettingsMutations
} from "@/components/settings/types";
import { LocaleSettingsConfirmModal } from "@/plugins/i18n/types";

@Component({})
export default class SettingsConfirmOverlay extends Vue {
  @Mutation(SettingsMutations.setConfirmModalStatus, {
    namespace: Namespace.Settings
  })
  setConfirmModalStatus!: (status: boolean) => void;

  @Mutation(SettingsMutations.setOpenConfirmModal, {
    namespace: Namespace.Settings
  })
  setOpenConfirmModal!: (status: boolean) => void;

  @Mutation(SettingsMutations.setConfirmModalMsg, {
    namespace: Namespace.Settings
  })
  setConfirmModalMsg!: (message: string) => void;

  @Getter(SettingsGetters.getConfirmModalMsg, {
    namespace: Namespace.Settings
  })
  getConfirmModalMsg!: string;

  LocaleSettingsConfirmModal = LocaleSettingsConfirmModal;

  mounted(): void {
    SpatialNavigation.focus("#confirm");
  }

  confirmDecision(status: boolean): void {
    this.setConfirmModalStatus(status);
    this.setConfirmModalMsg("");
    this.setOpenConfirmModal(false);
  }
}
